import Requestor from '@/api/Requestor';
import { authInstance } from '@/api/core';
class AuthApi extends Requestor {
    getAccessToken(data = {}) {
        return this.post({
            url: '/api/oauth2/token',
            data,
        });
    }
    refreshAccessToken(data = {}) {
        return this.post({
            url: '/api/oauth2/token',
            data,
        });
    }
}
export default new AuthApi(authInstance);
